import * as Sentry from '@sentry/browser';
import { getUser } from '~src/user';
import { op as openpanel } from './config/openpanelConfig';
import { initGleap } from './initGleap';
import { initEventListenersForTracking } from './utils/initEventListenersForTracking';
import { initGiottoPersonalizationRequests } from '~src/userRequest';

export const initAnalytics = async () => {
  const { user } = await getUser();

  Sentry.setUser({
    id: user.objectId,
    email: user.username,
    username: `${user.first_name || ''} ${user.last_name || ''}`.trim(),
    organization: user.org_pointer.nome,
  });

  Sentry.setContext('organization', {
    id: user.org_pointer.objectId,
    name: user.org_pointer.nome,
  });

  if (openpanel) {
    try {
      openpanel.identify({
        profileId: user.objectId,
        firstName: user.first_name || '',
        lastName: user.last_name || '',
        email: user.username || '',
        properties: {
          org_id: user.org_pointer.objectId,
          org_name: user.org_pointer.nome,
          org_plan: user.org_pointer.plan,
          org_lifecyclestage: user.org_pointer.tipo_istanza,
          org_amministratore_principale: user.super_admin,
          org_utente_attivo: user.user_status,
        },
      });

      if (user.org_pointer.objectId) {
        openpanel.upsertGroup({
          id: user.org_pointer.objectId,
          type: 'company',
          name: user.org_pointer.nome || '',
          properties: {
            plan: user.org_pointer.plan,
            lifecyclestage: user.org_pointer.tipo_istanza,
          },
        });
        openpanel.setGroup(user.org_pointer.objectId);
      }
    } catch (error) {
      console.error('Error identifying user in OpenPanel', error);
    }
  }

  // Initialize Gleap Messenger after the authenticated contact is available.
  await initGleap();
  initGiottoPersonalizationRequests();

  initEventListenersForTracking();
};
